import { render, staticRenderFns } from "./uni-image-upload.vue?vue&type=template&id=7ce875cc"
import script from "./uni-image-upload.vue?vue&type=script&lang=js"
export * from "./uni-image-upload.vue?vue&type=script&lang=js"
import style0 from "./uni-image-upload.vue?vue&type=style&index=0&id=7ce875cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports